import { api } from "@api/api";
import { Store } from "@modules/stores/types";
import { StoreFormValues } from "@modules/stores/validations";

export async function createStoreService(data: StoreFormValues): Promise<Store> {
  const { data: store } = await api.post<Store>("v1/store_admin/", data);

  return store;
}
